import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M10 1L5 6h4.25l-.0074 13H10.75V6H15z'],
  height: 20,
  width: 20,
});
